import { render } from "./QueryRegeneration.vue?vue&type=template&id=0e86b3d0&class=text-center"
import script from "./QueryRegeneration.vue?vue&type=script&lang=js"
export * from "./QueryRegeneration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__